(function () {
  'use strict';

  function initializeHomepage(root) {
    var home = root.matches && root.matches('.td-home') ? root : root.querySelector('.td-home');
    if (!home || home.dataset.initialized === 'true') return;

    home.dataset.initialized = 'true';
    home.classList.add('td-motion-ready');

    var heroTrack = home.querySelector('[data-td-hero-track]');
    var heroSlides = Array.prototype.slice.call(home.querySelectorAll('[data-td-hero-slide]'));
    var heroDots = Array.prototype.slice.call(home.querySelectorAll('[data-td-hero-dot]'));
    var heroIndex = 0;
    var heroTimer;

    function showHeroSlide(index) {
      if (!heroTrack || !heroSlides.length) return;
      heroIndex = (index + heroSlides.length) % heroSlides.length;
      heroTrack.style.transform = 'translateX(-' + (heroIndex * 100) + '%)';
      heroSlides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === heroIndex ? 'false' : 'true');
      });
      heroDots.forEach(function (dot, dotIndex) {
        var active = dotIndex === heroIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function restartHeroTimer() {
      window.clearInterval(heroTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      heroTimer = window.setInterval(function () { showHeroSlide(heroIndex + 1); }, 6000);
    }

    var heroPrev = home.querySelector('[data-td-hero-prev]');
    var heroNext = home.querySelector('[data-td-hero-next]');
    if (heroPrev) heroPrev.addEventListener('click', function () { showHeroSlide(heroIndex - 1); restartHeroTimer(); });
    if (heroNext) heroNext.addEventListener('click', function () { showHeroSlide(heroIndex + 1); restartHeroTimer(); });
    heroDots.forEach(function (dot) {
      dot.addEventListener('click', function () { showHeroSlide(Number(dot.dataset.tdHeroDot)); restartHeroTimer(); });
    });
    showHeroSlide(0);
    restartHeroTimer();

    var revealItems = home.querySelectorAll('.td-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('td-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });

      revealItems.forEach(function (item) { observer.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('td-visible'); });
    }

    var track = home.querySelector('[data-td-product-track]');
    var previousButton = home.querySelector('[data-td-prev]');
    var nextButton = home.querySelector('[data-td-next]');

    function scrollProducts(direction) {
      if (!track) return;
      var card = track.querySelector('.td-product');
      var distance = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * distance * 2, behavior: 'smooth' });
    }

    if (previousButton) previousButton.addEventListener('click', function () { scrollProducts(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { scrollProducts(1); });

    home.querySelectorAll('[data-td-demo-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var cartButton = document.querySelector('button[aria-label="Cart"], a[aria-label="Cart"]');
        if (cartButton) cartButton.click();
      });
    });

    var toTop = home.querySelector('[data-td-to-top]');
    if (toTop) {
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  function initializeSmoothScroll() {
    if (document.documentElement.dataset.tdSmoothScroll === 'true') return;
    document.documentElement.dataset.tdSmoothScroll = 'true';

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="#"]');
      if (!link) return;

      var destination = new URL(link.href, window.location.href);
      if (destination.pathname !== window.location.pathname || !destination.hash) return;

      var target = document.querySelector(destination.hash);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', destination.hash);
    });
  }

  function initializeAll(root) {
    if (root.matches && root.matches('.td-home')) initializeHomepage(root);
    root.querySelectorAll('.td-home').forEach(initializeHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSmoothScroll();
      initializeAll(document);
    });
  } else {
    initializeSmoothScroll();
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
